module.exports = require("@szgc/plt-ui-v2");